import CELL_DATA_TYPES from '../cell-types.config';
import { ACTIONS } from '../const.config';
import ROUTE_PATH from '../routes.config';

// Admin users module configurations
export const LISTING_COLUMNS = [
  {
    id: 'username',
    label: 'Company Name',
    width: '15%',
    align: 'left',
    dataKey: 'username',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'email',
    label: 'Email',
    width: '20%',
    align: 'left',
    dataKey: 'email',
    sortable: true,
    type: CELL_DATA_TYPES.EMAIL,
  },
  {
    id: 'type',
    label: 'Type',
    width: '10%',
    align: 'left',
    dataKey: 'type',
    sortable: true,
    type: CELL_DATA_TYPES.CONTENT_OWNER_ROLE,
  },
  {
    id: 'royality',
    label: 'Royality',
    width: '25%',
    align: 'left',
    dataKey: 'royality',
    sortable: true,
    type: CELL_DATA_TYPES.NUMBER,
  },
  {
    id: 'status',
    label: 'Status',
    width: '10%',
    align: 'center',
    dataKey: 'status',
    sortable: true,
    type: CELL_DATA_TYPES.STATUS,
  },
  {
    id: 'createdAt',
    label: 'Created At',
    width: '15%',
    align: 'right',
    dataKey: 'createdAt',
    sortable: true,
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];

export const LISTING_ACTIONS = [
  {
    action: ACTIONS.EDIT.value,
    label: ACTIONS.EDIT.label,
    link: ROUTE_PATH.CONTENT_OWNERS_EDIT,
  },
  {
    action: ACTIONS.VIEW.value,
    label: ACTIONS.VIEW.label,
    link: ROUTE_PATH.CONTENT_OWNERS_VIEW_DETAILS,
  },
  {
    action: ACTIONS.DELETE.value,
    label: ACTIONS.DELETE.label,
  },
];

export const VIEW_PROFILE_COLUMNS = [
  {
    id: 'username',
    label: 'Name/Company',
    dataKey: 'username',
    type: CELL_DATA_TYPES.TEXT,
    showFullGrid: true,
  },
  {
    id: 'firstName',
    label: 'First Name',
    dataKey: 'firstName',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'lastName',
    label: 'Last Name',
    dataKey: 'lastName',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'website',
    label: 'Website',
    dataKey: 'website',
    type: CELL_DATA_TYPES.TEXT,
    showFullGrid: true,
  },
  {
    id: 'type',
    label: 'Type',
    dataKey: 'type',
    type: CELL_DATA_TYPES.CONTENT_OWNER_ROLE,
  },
  {
    id: 'royality',
    label: 'Royality',
    dataKey: 'royality',
    type: CELL_DATA_TYPES.TEXT,
  },
];

export const VIEW_ADDRESS_COLUMNS = [
  {
    id: 'streetAddress',
    label: 'Street Address',
    dataKey: 'streetAddress',
    type: CELL_DATA_TYPES.TEXT,
    showFullGrid: true,
  },
  {
    id: 'city',
    label: 'City',
    dataKey: 'city',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'state',
    label: 'State',
    dataKey: 'state',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'zipcode',
    label: 'Zipcode',
    dataKey: 'zipcode',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'country',
    label: 'Country',
    dataKey: 'country',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'email',
    label: 'Email',
    dataKey: 'email',
    type: CELL_DATA_TYPES.EMAIL,
  },
  {
    id: 'phone',
    label: 'Phone',
    dataKey: 'phone',
    type: CELL_DATA_TYPES.TEXT,
  },
];

export const VIEW_PAYMENT_COLUMNS = [
  {
    id: 'bank1',
    label: 'Bank 1',
    dataKey: 'bank1',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'bankAcc1',
    label: 'Bank Account 1',
    dataKey: 'bankAcc1',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'bank2',
    label: 'Bank 2',
    dataKey: 'bank2',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'bankAcc2',
    label: 'Bank Account 2',
    dataKey: 'bankAcc2',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'bankPreference',
    label: 'Bank Preference',
    dataKey: 'bankPreference',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'rawBankInfo',
    label: 'Unprocessed Bank Info',
    dataKey: 'rawBankInfo',
    type: CELL_DATA_TYPES.TEXT,
  },
];

export const VIEW_OTHER_COLUMNS = [
  {
    id: 'canEditLicense',
    label: 'Can Edit License',
    dataKey: 'canEditLicense',
    type: CELL_DATA_TYPES.BOOL,
  },
  {
    id: 'timezone',
    label: 'Time zone',
    dataKey: 'timezone',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'info',
    label: 'Notes',
    dataKey: 'info',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'status',
    label: 'Status',
    dataKey: 'status',
    type: CELL_DATA_TYPES.STATUS,
  },
  {
    id: 'channels',
    label: 'Channels Preference',
    dataKey: 'channelsName',
    type: CELL_DATA_TYPES.TEXT,
    showFullGrid: true,
  },
  {
    id: 'createdAt',
    label: 'Created At',
    dataKey: 'createdAt',
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
  {
    id: 'modifiedAt',
    label: 'Modified At',
    dataKey: 'modifiedAt',
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];
